// 送信失敗の連続回数から「報告フォーム導線を出すべきか」を判定する純粋関数。
// useSubmitInvestmentStyleDiagnosis.ts は notistack/react-router/capacitor 連携の重い依存を持つため、
// 判定ロジックだけをここに切り出してテストから直接検証できるようにする
// （investmentStyleDiagnosisStorage.ts / investmentStyleDiagnosisValidation.ts と同じ狙い）。

// この回数連続で送信が失敗したら、通常のスナックバーに代えて報告フォームへの導線を出す。
export const CONSECUTIVE_FAILURE_THRESHOLD_FOR_SUPPORT_LINK = 3;

// 閾値に達した回以降は毎回 true を返す。ここを厳密一致にすると、閾値に達した回のスナックバーを
// ユーザーが閉じてしまった場合に導線へ二度と戻れなくなる（永続表示だが閉じるボタン付きのため）。
export const shouldShowSupportLink = (consecutiveFailureCount: number): boolean =>
  consecutiveFailureCount >= CONSECUTIVE_FAILURE_THRESHOLD_FOR_SUPPORT_LINK;
